import { useEffect, useState } from 'react';

export function useTransition() {
    const [visible, setVisible] = useState(false);
    
    useEffect(() => {
        setVisible(true);

        return () => setVisible(false);
    }, []);

    return visible;
}